import { FaroRoutes } from '@grafana/faro-react';
import { AdminAdminsListPage } from '@pages/Admin/AdminsListPage';
import { AdminASOneSubscriptionDetails } from '@pages/Admin/ASOneSubscriptionDetails';
import { AdminASOneSubscriptionsPage } from '@pages/Admin/ASOneSubscriptions';
import { AdminAttorneysAccessPage } from '@pages/Admin/AttorneysAccessPage';
import { AdminAttorneyPasscodesPage } from '@pages/Admin/AttorneysPasscodesPage';
import { AdminAttorneyUsersPage } from '@pages/Admin/AttorneyUsersPage';
import { AttorneyViewFeatureFlags } from '@pages/Admin/AttorneyViewFeatureFlags';
import { AdminAuditLogsPage } from '@pages/Admin/AuditLogsPage';
import { ApiDocsHubPage } from '@pages/Admin/ApiDocsPages/ApiDocsHubPage';
import { InternalApiDocsPage } from '@pages/Admin/ApiDocsPages/InternalApiDocsPage';
import { OrganizationApiDocsPage } from '@pages/Admin/ApiDocsPages/OrganizationApiDocsPage';
import { AdminBillingAccountDetailsPage } from '@pages/Admin/BillingAccountDetailsPage';
import { BillingAccountsPage } from '@pages/Admin/BillingAccountsPage';
import { AdminCanvasCourseStudentsPage } from '@pages/Admin/CanvasCourseStudentsPage';
import { AdminCanvasCoursesPage } from '@pages/Admin/CanvasCoursesPage';
import { AdminCloudLayoutsPage } from '@pages/Admin/CloudLayoutsPage';
import { AdminDashboardPage } from '@pages/Admin/DashboardPage';
import { ComponentShowcasePage } from '@pages/Admin/ComponentShowcasePage';
import { AsrProxyConsolePage } from '@pages/Admin/AsrProxyConsolePage';
import { AdminDiffPage } from '@pages/Admin/DiffPage';
import { FeatureFlags } from '@pages/Admin/FeatureFlags';
import { AdminJobDetailsPage } from '@pages/Admin/JobDetailsPage';
import { AdminJobsReportPage } from '@pages/Admin/JobsReportPage';
import { LLMPrompts } from '@pages/Admin/LLMPrompts';
import { NoticeExtractor } from '@pages/Admin/NoticeExtractor';
import { AdminOrganizationDetailsPage } from '@pages/Admin/OrganizationDetailsPage';
import { AdminOrganizationInvitationsListPage } from '@pages/Admin/OrganizationInvitationsListPage';
import { AdminOrganizationsListPage } from '@pages/Admin/OrganizationsListPage';
import { AdminOrganizationUsersListPage } from '@pages/Admin/OrganizationUsersListPage';
import { AdminRepositoryPage } from '@pages/Admin/RepositoryPage';
import { AdminSettingsPage } from '@pages/Admin/SettingsPage';
import { AdminSMSCountriesList } from '@pages/Admin/SMSCountries';
import { AdminSMSWhitelist } from '@pages/Admin/SMSWhitelist';
import { AdminSSOProviderListPage } from '@pages/Admin/SSOProviders';
import { AdminTeamDetailsPage } from '@pages/Admin/TeamDetailsPage';
import { AdminTransactionCodesPage } from '@pages/Admin/TransactionCodesPage';
import { AdminTransactionsPage } from '@pages/Admin/TransactionsPage';
import { AdminTranscriptPlayerPage } from '@pages/Admin/TranscriptPlayer';
import { AdminTranscriptReviewPage } from '@pages/Admin/TranscriptReviewPage';
import { AdminUserDetailsPage } from '@pages/Admin/UserDetailsPage';
import { AdminUsersListPage } from '@pages/Admin/UsersListPage';
import { AdminUtteranceConfidencePage } from '@pages/Admin/UtteranceConfidencePage';
import { AdminWorkspaceDetailsPage } from '@pages/Admin/WorkspaceDetailsPage';
import { AdminWorkspacesListPage } from '@pages/Admin/WorkspacesListPage';
import { OrganizationApiDocsPage as OrganizationApiDocsPublicPage } from '@pages/OrganizationApiDocsPage';
import { AccessRequestPage } from '@pages/User/AccessRequestPage';
import { AccountPage } from '@pages/User/AccountPage';
import { AllJobsPage } from '@pages/User/AllJobs';
import { ASOneSubscriptionDetails } from '@pages/User/ASOneSubscriptionDetails';
import { AttorneysReportPage } from '@pages/User/AttorneysPage';
import { BillingAccountDetailsPage } from '@pages/User/BillingAccountDetailsPage';
import { DashboardPage } from '@pages/User/DashboardPage';
import { DesktopAppHelpPage } from '@pages/User/DesktopAppHelpPage';
import { InvitationsPage } from '@pages/User/InvitationsPage';
import { TrainingAdditionalResourcesPage } from '@pages/User/TrainingPages/TrainingAdditionalResourcesPage';
import { TrainingAgencyPage } from '@pages/User/TrainingPages/TrainingAgencyPage';
import { TrainingEditorProoferPage } from '@pages/User/TrainingPages/TrainingEditorProoferPage';
import { TrainingFolderPage } from '@pages/User/TrainingPages/TrainingFolderPage';
import { TrainingHubPage } from '@pages/User/TrainingPages/TrainingHubPage';
import { TrainingWatchPage } from '@pages/User/TrainingPages/TrainingWatchPage';
import { JobDetailsPage } from '@pages/User/JobDetailsPage';
import { JobsListPage } from '@pages/User/JobsListPage';
import { JobsReport } from '@pages/User/JobsReport';
import { MemberReportsPage } from '@pages/User/MemberReportsPage';
import { MembersPage } from '@pages/User/MembersPage';
import { NewJobPage } from '@pages/User/NewJobPage';
import { NotificationSettingsPage } from '@pages/User/NotificationSettingsPage';
import { NotificationsPage } from '@pages/User/NotificationsPage';
import { OrganizationDetails } from '@pages/User/OrganizationDetailsPage';
import { OrganizationsListPage } from '@pages/User/OrganizationsListPage';
import { RepositoriesListPage } from '@pages/User/RepositoriesListPage';
import { RepositoryPage } from '@pages/User/RepositoryPage';
import { ScriberDashboardPage } from '@pages/User/ScriberDashboardPage';
import { TeamDetailsPage } from '@pages/User/TeamDetailsPage';
import { TeamsPage } from '@pages/User/TeamsPage';
import { UserDetailsPage } from '@pages/User/UserDetailsPage';
import { UserJobsReport } from '@pages/User/UserJobsReport';
import { UserNoticeExtractor } from '@pages/User/NoticeExtractor';
import { WorkspaceDetailsPage } from '@pages/User/WorkspaceDetailsPage';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';
import { AuthenticatedAppShell } from '../AppShell';

export const Routes = () => {
  const { me, organization } = useAuthContext();

  if (!me.id) {
    return null;
  }

  const isVsAdmin = me?.roles?.includes('ROLE_VS_ADMIN');
  const isSuperAdmin = me?.roles?.includes('ROLE_SUPER_ADMIN');
  const isOrgAdmin = organization?.permissions?.manageOrganization;

  // const workspaceViewReports = (workspace?.Teams ?? []).find((team) => team.viewReports);
  // const shouldShowReports = !!workspaceViewReports;
  const shouldShowReports = !!organization?.permissions?.viewReports;

  const shouldShowAllJobs =
    !!organization?.permissions?.manageWorkspaces ||
    !!organization?.permissions?.manageOrganization ||
    !!organization?.permissions?.owner;
  const shouldShowUsers = !!organization?.permissions?.manageMembers;
  const canManageOrganization = !!organization?.permissions?.manageOrganization;

  const defaultOrg = organization?.id ? organization : undefined;

  let adminRoutes = <></>;
  if (isVsAdmin) {
    adminRoutes = (
      <>
        <Route path={routes.adminDiff.pattern} element={<AdminDiffPage />} />
        <Route path={routes.adminTranscriptReview.pattern} element={<AdminTranscriptReviewPage />} />
        <Route path={routes.adminTranscriptReviewJob.pattern} element={<AdminTranscriptReviewPage />} />
        <Route path={routes.adminJobUtterances.pattern} element={<AdminUtteranceConfidencePage />} />
        <Route path={routes.adminJobTranscriptPlayer.pattern} element={<AdminTranscriptPlayerPage />} />
        <Route path={routes.adminDashboard.pattern} element={<AdminDashboardPage />} />
        {isSuperAdmin ? <Route path={routes.adminAdminsList.pattern} element={<AdminAdminsListPage />} /> : null}
        <Route path={routes.adminCanvasCoursesList.pattern} element={<AdminCanvasCoursesPage />} />
        <Route path={routes.adminCanvasCourseStudentsPage.pattern} element={<AdminCanvasCourseStudentsPage />} />
        <Route path={routes.adminOrganizationsList.pattern} element={<AdminOrganizationsListPage />} />
        <Route path={routes.adminCloudLayouts.pattern} element={<AdminCloudLayoutsPage />} />
        <Route path={routes.adminOrganizationDetails.pattern} element={<AdminOrganizationDetailsPage />} />
        <Route path={routes.adminWorkspacesList.pattern} element={<AdminWorkspacesListPage />} />
        <Route path={routes.adminWorkspaceDetails.pattern} element={<AdminWorkspaceDetailsPage />} />
        <Route path={routes.adminTeamDetails.pattern} element={<AdminTeamDetailsPage />} />
        <Route path={routes.adminRepositoryDetails.pattern} element={<AdminRepositoryPage />} />
        <Route path={routes.adminSettings.pattern} element={<AdminSettingsPage />} />
        <Route path={routes.adminUsersList.pattern} element={<AdminUsersListPage />} />
        <Route path={routes.adminAuditLogs.pattern} element={<AdminAuditLogsPage />} />
        <Route path={routes.adminBillingAccountsList.pattern} element={<BillingAccountsPage />} />
        <Route path={routes.adminJobsReport.pattern} element={<AdminJobsReportPage />} />
        <Route path={routes.adminOrganizationUsersList.pattern} element={<AdminOrganizationUsersListPage />} />
        <Route
          path={routes.adminOrganizationInvitationsList.pattern}
          element={<AdminOrganizationInvitationsListPage />}
        />
        <Route path={routes.adminUserDetails.pattern} element={<AdminUserDetailsPage />} />
        <Route path={routes.adminSSOProvidersList.pattern} element={<AdminSSOProviderListPage />} />
        <Route path={routes.adminSubscriptions.pattern} element={<AdminASOneSubscriptionsPage />} />
        <Route path={routes.adminTransactions.pattern} element={<AdminTransactionsPage />} />
        <Route path={routes.adminTransactionsForBillingAccount.pattern} element={<AdminTransactionsPage />} />
        <Route path={routes.adminSMSCountries.pattern} element={<AdminSMSCountriesList />} />
        <Route path={routes.adminSMSWhitelist.pattern} element={<AdminSMSWhitelist />} />
        <Route path={routes.adminFeatureFlags.pattern} element={<FeatureFlags />} />
        <Route path={routes.adminAttorneyViewFeatureFlags.pattern} element={<AttorneyViewFeatureFlags />} />
        <Route path={routes.adminTransactionCodesList.pattern} element={<AdminTransactionCodesPage />} />
        <Route path={routes.adminBillingAccountDetails.pattern} element={<AdminBillingAccountDetailsPage />} />
        <Route path={routes.adminAttorneysAccess.pattern} element={<AdminAttorneysAccessPage />} />
        <Route path={routes.adminAttorneysPasscodes.pattern} element={<AdminAttorneyPasscodesPage />} />
        <Route path={routes.adminAttorneyUsers.pattern} element={<AdminAttorneyUsersPage />} />
        <Route path={routes.adminJobDetails.pattern} element={<AdminJobDetailsPage />} />
        <Route
          path={routes.adminAutoScriptOneSubscriptionDetails.pattern}
          element={<AdminASOneSubscriptionDetails />}
        />
        <Route path={routes.adminPrompts.pattern} element={<LLMPrompts />} />
        <Route path={routes.adminNoticeExtractor.pattern} element={<NoticeExtractor />} />
        <Route path={routes.adminComponentShowcase.pattern} element={<ComponentShowcasePage />} />
        <Route path={routes.adminAsrProxyConsole.pattern} element={<AsrProxyConsolePage />} />
        <Route path={routes.adminApiDocs.pattern} element={<ApiDocsHubPage />} />
        <Route path={routes.adminApiDocsOrganizationApi.pattern} element={<OrganizationApiDocsPage />} />
        <Route path={routes.adminApiDocsInternalApi.pattern} element={<InternalApiDocsPage />} />
      </>
    );
  }

  return (
    <AuthenticatedAppShell>
      <FaroRoutes routesComponent={Switch}>
        {adminRoutes}
        <Route path={routes.notifications.pattern} element={<NotificationsPage />} />
        <Route path={routes.notificationSettings.pattern} element={<NotificationSettingsPage />} />

        {shouldShowAllJobs ? <Route path={routes.allJobs.pattern} element={<AllJobsPage />} /> : null}

        {shouldShowReports ? (
          <>
            <Route path={routes.jobsReport.pattern} element={<JobsReport />} />
            <Route path={routes.userJobsReport.pattern} element={<UserJobsReport />} />
          </>
        ) : null}

        {shouldShowUsers ? (
          <>
            <Route path={routes.organizationMembers.pattern} element={<MembersPage />} />
            <Route path={routes.organizationTeams.pattern} element={<TeamsPage />} />
            <Route path={routes.invitations.pattern} element={<InvitationsPage />} />
            {shouldShowReports ? (
              <Route path={routes.organizationMemberReports.pattern} element={<MemberReportsPage />} />
            ) : null}
          </>
        ) : null}

        <Route path={routes.organizationAttorneysReport.pattern} element={<AttorneysReportPage />} />

        <Route path={routes.accountPage.pattern} element={<AccountPage />} />

        {canManageOrganization ? (
          <Route path={routes.organizationApiDocs.pattern} element={<OrganizationApiDocsPublicPage />} />
        ) : null}

        <Route path={routes.desktopAppHelp.pattern} element={<DesktopAppHelpPage />} />

        <Route path={routes.training.pattern} element={<TrainingHubPage />} />
        <Route path={routes.trainingEditorProofer.pattern} element={<TrainingEditorProoferPage />} />
        <Route path={routes.trainingAgency.pattern} element={<TrainingAgencyPage />} />
        <Route path={routes.trainingFolder.pattern} element={<TrainingFolderPage />} />
        <Route path={routes.trainingWatch.pattern} element={<TrainingWatchPage />} />
        <Route path={routes.trainingAdditionalResources.pattern} element={<TrainingAdditionalResourcesPage />} />

        <Route path={routes.userDetails.pattern} element={<UserDetailsPage />} />

        <Route path={routes.dashboard.pattern} element={isOrgAdmin ? <DashboardPage /> : <ScriberDashboardPage />} />

        <Route path={routes.jobsList.pattern} element={<JobsListPage />} />

        <Route path={routes.jobDetails.pattern} element={<JobDetailsPage />} />

        <Route path={routes.noticeExtractor.pattern} element={<UserNoticeExtractor />} />

        <Route path={routes.workspaceDetails.pattern} element={<WorkspaceDetailsPage />} />

        <Route path={routes.newJob.pattern} element={<NewJobPage newJob={true} />} />

        <Route path={routes.jobEdit.pattern} element={<NewJobPage newJob={false} />} />

        <Route path={routes.newRepository.pattern} element={<RepositoryPage />} />

        <Route path={routes.repositoryDetails.pattern} element={<RepositoryPage />} />

        <Route path={routes.billingAccount.pattern} element={<BillingAccountDetailsPage />} />

        <Route path={routes.autoScriptOneSubscriptionDetails.pattern} element={<ASOneSubscriptionDetails />} />

        <Route path={routes.requestAccess.pattern} element={<AccessRequestPage />} />

        <Route path={routes.organizationsList.pattern} element={<OrganizationsListPage />} />

        <Route path={routes.teamDetails.pattern} element={<TeamDetailsPage />} />

        <Route path={routes.organizationDetails.pattern} element={<OrganizationDetails />} />

        <Route path={routes.repositoriesList.pattern} element={<RepositoriesListPage />} />

        <Route
          path="*"
          element={
            defaultOrg?.slug ? (
              <Navigate to={routes.dashboard.make(defaultOrg.slug)} replace />
            ) : (
              <Navigate to={routes.organizationsList.make()} replace />
            )
          }
        />
      </FaroRoutes>
    </AuthenticatedAppShell>
  );
};
